import React, { useEffect } from 'react'
import NavbarTop from './../components/global/NavbarTop';

import CaseStudiesProcurementContent from './../components/CaseStudies/CaseStudiesProcurementContent';
import { useTranslation } from 'react-i18next';
import { selectLanguage } from './../redux/language/selector';
import { useSelector } from 'react-redux';

const CaseStudiesProcurement = () => {
  const {t} = useTranslation()

  const language = useSelector(selectLanguage)

    useEffect(()=> {
        document.title = t('case-studies-procurement-page.case-studies-procurement-page-title')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[language])
    
  return (
    <>
        <NavbarTop/>
        <CaseStudiesProcurementContent/>
    </>
  )
}

export default CaseStudiesProcurement